<template>
  <div class="home-container">
    <div class="s1">
      <div class="section-title"><img src="../assets/naic/home/s1.png" /></div>
      <div class="content-wrap">
        <div class="cmpt-item" v-for="(item, index) in cmpts" :key="index">
          <div class="cover" @click="handleNav2CmptDetail(item.id)">
            <img :src="item.cover" />
          </div>
          <div class="texts">
            <div class="cmpt-title">
              <h2 @click="handleNav2CmptDetail(item.id)">{{ item.title }}</h2>
              <span v-for="tag in item.tags" :key="tag"> {{ tag }}</span>
            </div>
            <div class="cmpt-des">
              <p>{{ item.des }}</p>
            </div>
            <div class="cmpt-organ">
              <p>
                <span>举办单位：</span><span>{{ item.organ[1] }}</span
                ><span>承办单位：</span><span>{{ item.organ[2] }}</span>
              </p>
              <p>
                <span>协办单位：</span><span>{{ item.organ[3] }}</span>
              </p>
              <p><span>支持单位：</span><span>广东省人工智能与机器人学会</span></p>
            </div>
          </div>
          <div class="number-wrap">
            <div class="reward">
              <h3>奖励</h3>
              <p>{{ item.rewards }}</p>
            </div>
            <div class="signup-users">
              <h3>参赛队伍</h3>
              <p>{{ item.teams }}</p>
            </div>
          </div>
          <div class="state">
            <img
              src="../assets/naic/home/state-1.png"
              v-if="item.state === 'state-1'"
            />
            <img
              src="../assets/naic/home/state-2.png"
              v-else-if="item.state === 'state-2'"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="s2">
      <div class="section-title"><img src="../assets/naic/home/s2.png" /></div>
      <div class="content-wrap">
        <video
          src="https://s3.cn-north-1.amazonaws.com.cn/files.datafountain.cn/uploads/admin/%E5%BC%80%E5%B9%95%E5%AE%A3%E4%BC%A0%E7%89%878.mp4"
          controls
          poster="../assets/naic/home/s2-poster.jpg"
        ></video>
      </div>
    </div>

    <div class="s3">
      <div class="section-title"><img src="../assets/naic/home/s3.png" /></div>
      <div class="content-wrap">
        <div
          class="left"
          @click="
            handleNav2('https://mp.weixin.qq.com/s/OgExAzchjLii0uClQzcwFQ')
          "
        >
          <img src="../assets/naic/home/s3-l5.jpg" />
          <div class="text">
            <div class="title">
              第四届全国人工智能大赛晋级决赛名单公示
            </div>
            <div class="time"><i class="icon-time-1"></i> 2023-11-10 18:56</div>
          </div>
        </div>
        <div class="right">
          <div class="s3ri">
            <div
              class="img"
              @click="
                handleNav2('https://mp.weixin.qq.com/s/a84AqBFFHqxlqbP7-hYyvg')
              "
            >
              <img src="../assets/naic/home/s3-l5.jpg" />
            </div>
            <div class="text">
              <h3
                @click="
                  handleNav2(
                    'https://mp.weixin.qq.com/s/a84AqBFFHqxlqbP7-hYyvg'
                  )
                "
              >
              2023年全国人工智能大赛初赛晋级复赛名单公示
              </h3>
              <p><i class="icon-time-2"></i>2023-08-16 12:15</p>
            </div>
          </div>
          <div class="s3ri">
            <div
              class="img"
              @click="
                handleNav2('https://mp.weixin.qq.com/s/DeOljNJFTCjE_0WmADgFPQ')
              "
            >
              <img src="../assets/naic/home/s3-l5.jpg" />
            </div>
            <div class="text">
              <h3
                @click="
                  handleNav2(
                    'https://mp.weixin.qq.com/s/DeOljNJFTCjE_0WmADgFPQ'
                  )
                "
              >
              初赛交锋 如火如荼——第四届全国人工智能大赛火热进行中
              </h3>
              <p><i class="icon-time-2"></i> 2023-07-04 17:00</p>
            </div>
          </div>
          <div class="s3ri">
            <div
              class="img"
              @click="
                handleNav2('https://mp.weixin.qq.com/s/-12cNrx4H44MFUF6lzu6xw')
              "
            >
              <img src="../assets/naic/home/s32.png" />
            </div>
            <div class="text">
              <h3
                @click="
                  handleNav2(
                    'https://mp.weixin.qq.com/s/-12cNrx4H44MFUF6lzu6xw'
                  )
                "
              >
              第四届全国人工智能大赛 三大赛题专家答疑
              </h3>
              <p><i class="icon-time-2"></i>2023-07-12 17:03</p>
            </div>
          </div>
          <!-- <div class="s3ri">
            <div
              class="img"
              @click="
                handleNav2('https://mp.weixin.qq.com/s/ypM3FnKF3t7CJfDa4wUaAw')
              "
            >
              <img src="../assets/naic/home/s34.png" />
            </div>
            <div class="text">
              <h3
                @click="
                  handleNav2(
                    'https://mp.weixin.qq.com/s/ypM3FnKF3t7CJfDa4wUaAw'
                  )
                "
              >
                2021全国人工智能大赛复赛晋级决赛名单公示
              </h3>
              <p><i class="icon-time-2"></i>2022-04-20 17:21</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="s4-bg"></div>

    <div class="s4">
      <div class="section-title"><img src="../assets/naic/home/s4.png" /></div>
      <div class="content-wrap">
        <div class="s41 s4-s">
          <h4>报名</h4>
          <p>04.27-07.27</p>
          <div class="img">
            <img src="../assets/naic/home/s4i.png" />
          </div>
        </div>
        <div class="s42 s4-s">
          <h4>初赛</h4>
          <p>05.08-07.31</p>
          <div class="img">
            <img src="../assets/naic/home/s4i.png" />
          </div>
        </div>
        <div class="s43 s4-s">
          <h4>复赛</h4>
          <p>09.11-10.20</p>
          <div class="img">
            <img src="../assets/naic/home/s4i.png" />
          </div>
        </div>
        <div class="s44 s4-s">
          <h4>决赛</h4>
          <p>12月</p>
          <div class="img">
            <img src="../assets/naic/home/s4i.png" />
          </div>
        </div>
      </div>
    </div>

    <div class="s5">
      <div class="section-title"><img src="../assets/naic/home/s5.png" /></div>
      <div class="content-wrap">
        <div class="item">
          <div class="img">
            <img src="../assets/naic/home/s51.png" />
          </div>
          <div class="text">
            <div class="label">一等奖</div>
            <div class="track">1支队伍/赛道</div>
            <div class="reward">
              ¥ 50万
              <br />
              <span>（+50万突出贡献奖励）</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="../assets/naic/home/s52.png" />
          </div>
          <div class="text">
            <div class="label">二等奖</div>
            <div class="track">2支队伍/赛道</div>
            <div class="reward">¥ 20万/队</div>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="../assets/naic/home/s53.png" />
          </div>
          <div class="text">
            <div class="label">三等奖</div>
            <div class="track">3支队伍/赛道</div>
            <div class="reward">¥ 10万/队</div>
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="../assets/naic/home/s54.png" />
          </div>
          <div class="text">
            <div class="label">优胜奖</div>
            <div class="track">4支队伍/赛道</div>
            <div class="reward">¥ 2万/队</div>
          </div>
        </div>
      </div>

      <p class="s5-tips">* 具体奖项信息详见各赛道【大赛激励】说明</p>
    </div>

    <div class="s6">
      <div class="section-title"><img src="../assets/naic/home/s6.png" /></div>
      <div class="content-wrap">
        <div class="line">
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s61.png" />
            </div>
            <div class="label">奖金政策支持</div>
            <p>大赛决赛获奖团队可获得组委会颁发的奖金和相关政策支持</p>
          </div>

          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s62.png" />
            </div>
            <div class="label">配套支持</div>
            <p>落户深圳的大赛优秀项目，可获得各区资金、场地等配套支持</p>
          </div>

          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s63.png" />
            </div>
            <div class="label">政策资助</div>
            <p>组委会鼓励参赛队伍开源作品，对开源的团体，将考虑额外奖励</p>
          </div>
        </div>
        <div class="line">
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s64.png" />
            </div>
            <div class="label">科研支持</div>
            <p>
              参赛项目及团队经过评估将有机会在鹏城实验室立项，获得鹏城实验室科研经费支持及人才政策支持
            </p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s65.png" />
            </div>
            <div class="label">创业支持</div>
            <p>
              入围决赛、获决赛前三等奖及获优秀奖的团队组选手，待成立企业后，按规定给予创新创业资助支持，选手政策支持自参赛次年起两年内有效
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="s7">
      <div class="section-title"><img src="../assets/naic/home/s7.png" /></div>
      <div class="content-wrap">
        <div class="line line-1">
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s71.png" />
            </div>
            <h3>于全</h3>
            <p>主席</p>
            <p>
              中国工程院院士 <br />
              &nbsp;
            </p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s72.png" />
            </div>
            <h3>高文</h3>
            <p>主席</p>
            <p>中国工程院院士<br />鹏城实验室主任</p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s73.png" />
            </div>
            <h3>丁文华</h3>
            <p>主席</p>
            <p>
              中国工程院院士 <br />
              &nbsp;
            </p>
          </div>
        </div>
      </div>
      <div class="content-wrap">
        <div class="line line-2">
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s74.png" />
            </div>
            <h3>陈文光</h3>
            <p>副主席</p>
            <p>清华大学教授 <br />中国计算机学会副秘书长</p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s75.png" />
            </div>
            <h3>张伟</h3>
            <p>副主席</p>
            <p>
              澳大利亚 <br />
              新南威尔士大学教授
            </p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s76.png" />
            </div>
            <h3>段凌宇</h3>
            <p>副主席</p>
            <p>
              北京大学教授 <br />
              &nbsp;
            </p>
          </div>
          </div>
          
        <div class="line line-3">
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s77.png" />
            </div>
            <h3>宁金辉</h3>
            <p>副主席</p>
            <p>
              国家广电局广播电视规划院 <br />
              制播研究所所长
            </p>
          </div>
          <div class="item">
            <div class="img">
              <img src="../assets/naic/home/s78.png" />
            </div>
            <h3>张迪煊</h3>
            <p>副主席</p>
            <p>
              华为昇腾计算业务总裁  <br />
              &nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="s8">
      <div class="content-wrap">
        <h2>快来加入吧！</h2>
        <p>赛道任你选，大奖等你拿</p>
        <a @click="handleNav2Signup"> 立即加入 </a>
      </div>
    </div>
  </div>
</template>

<script>
  // import axios from "axios";
  import s11 from "../assets/naic/home/s11.jpg";
  import s12 from "../assets/naic/home/s12.jpg";
  import s13 from "../assets/naic/home/s13.jpg";
  // import bus from "../utils/EventBus";

  export default {
    name: "home",
    data() {
      return {
        totalTeams: 0,
        totalUsers: 0,
        cmpts: [
          {
            id: 645,
            cover: s11,
            title: "AI+无线通信",
            url: "https://www.datafountain.cn/competitions/645",
            tags: ["AI", "无线通信"],
            des: "AI+无线通信赛道将摒弃物理层信道测量、信道反馈等传统方法，基于无线地图的无反馈通信系统设计，挖掘无线大数据中的隐藏地理信息，利用AI射频地图使能高效信息传输，进一步提升空口资源使用效率，为下一代无线接入网（RAN）技术提供理论支撑与技术验证。 ",
            organ: [
              "深圳市人民政府",
              "深圳市科技创新委员会、鹏城实验室",
              "新一代人工智能产业技术创新战略联盟(AITISA)",
              "中国工商银行股份有限公司深圳市分行、华为技术有限公司、深圳市鹏城实验室科教基金会",
            ],
            rewards: "￥ 1,780,000",
            signupUsers: "0",
            teams: 2829,
            state: "state-2",
          },
          {
            id: 644,
            cover: s12,
            title: "AI+视觉特征编码",
            url: "https://www.datafountain.cn/competitions/644",
            tags: ["AI", "视觉特征编码"],
            des: "AI+视觉特征编码赛道将面向智能交通场景的事件检测任务，针对特征流式数据进行压缩重建，通过高维张量编码，提升任务精度和视觉分析的综合性能；通过引入特征流与模型学习的泛化能力测试，验证真实应用场景下技术泛化能力，对特征流式数据的压缩重建利用提出了更高要求。",
            organ: [
              "深圳市人民政府",
              "深圳市科技创新委员会、鹏城实验室",
              "新一代人工智能产业技术创新战略联盟(AITISA)",
              "中国工商银行股份有限公司深圳市分行、华为技术有限公司、深圳市鹏城实验室科教基金会",
            ],
            rewards: "￥ 1,780,000",
            signupUsers: "0",
            teams: 2839,
            state: "state-2",
          },
          {
            id: 643,
            cover: s13,
            title: "AI+视频质量评价",
            url: "https://www.datafountain.cn/competitions/643",
            tags: ["AI", "视频"],
            des: "AI+视频质量评价赛道，是全球首个面向广色域、高帧率、高比特数4K超高清视频压缩质量评价的人工智能赛道，采用更高格式视频序列和更专业的主观标签数据集，挖掘准确性高、鲁棒性强的AI评价算法，提升视频传输分发质量，保障视听媒体用户体验。",
            organ: [
              "深圳市人民政府",
              "深圳市科技创新委员会、鹏城实验室",
              "新一代人工智能产业技术创新战略联盟(AITISA)",
              "中国工商银行股份有限公司深圳市分行、华为技术有限公司、深圳市鹏城实验室科教基金会",
            ],
            rewards: "￥ 1,780,000",
            signupUsers: "0",
            teams: 1624,
            state: "state-2",
          },
        ],
      };
    },
    methods: {
      toThousands(number, bit = 0, sign = ',', gapnum = 3) {
        if (isNaN(number)) return number;
        number = Number(number);
        //设置接收参数的默认值
        bit = arguments[1] != undefined ? arguments[1] : 2;
        sign = arguments[2] != undefined ? arguments[2] : " ";
        gapnum = arguments[3] != undefined ? arguments[3] : 3;
        let str = "";

        number = number.toFixed(bit); //格式化
        let realnum = number.split(".")[0]; //整数位(使用小数点分割整数和小数部分)
        let decimal = number.split(".")[1]; //小数位
        let realnumarr = realnum.split(""); //将整数位逐位放进数组 ["1", "2", "3", "4", "5", "6"]

        //把整数部分从右往左拼接，每bit位添加一个sign符号
        for (let i = 1; i <= realnumarr.length; i++) {
          str = realnumarr[realnumarr.length - i] + str;
          if (i % gapnum === 0) {
            str = sign + str; //每隔gapnum位前面加指定符号
          }
        }

        //当遇到 gapnum 的倍数的时候，会出现比如 ",123",这种情况，所以要去掉最前面的 sign
        str = realnum.length % gapnum === 0 ? str.substr(1) : str;
        //重新拼接实数部分和小数位
        realnum = str + (decimal ? "." + decimal : "");
        return realnum;
      },
      handleNav2Signup() {
        // 页面滚动到500高度
        window.scrollTo(0, 720);
      },
      handleNav2(url) {
        window.open(url);
      },
      handleNav2CmptDetail(id) {
        window.scrollTo(0, 0);
        this.$router.push(`/competitions?id=${id}`);
      },
      // async fetchCmptInfo() {
      //   const { data } = await axios({ url: "/proxy/cmptinfos" });

      //   data.forEach((i) => {
      //     this.cmpts.forEach((j) => {
      //       if (i.id === j.id) {
      //         j.signupUsers = i.users;
      //         j.teams = i.teams;
      //         j.rewards = `￥ ${this.toThousands(i.reward, 0, ',', 3)}`;
      //         this.totalTeams += i.teams;
      //         this.totalUsers += i.users;
      //         if (new Date(i.endTime).getTime() > new Date().getTime()) {
      //           j.state = "state-1";
      //         }
      //       }
      //     });
      //   });
      //   bus.emit("total", { team: this.totalTeams, user: this.totalUsers });
      // },
    },
    mounted() {
      // this.fetchCmptInfo();
    },
  };
</script>

<style scoped lang="scss">
  .home-container {
    background: #f8f8f8;
    position: relative;
    padding-bottom: 41px;

    .s4-bg {
      width: 100%;
      height: 922px;
      position: absolute;
      left: -1px;
      top: 2234px;
      background: url("../assets/naic/home/s4-bg.png") no-repeat center center;
      background-size: 100% 922px;
    }

    .s1 {
      padding-top: 77px;
      max-width: 1200px;
      margin: 0 auto;
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        padding-top: 40px;
        .cmpt-item {
          &:not(:nth-last-of-type(1)) {
            margin-bottom: 18px;
          }
          position: relative;
          .state {
            position: absolute;
            right: -3px;
            top: -3px;
            width: 79px;
            height: 79px;
            img {
              width: 79px;
              height: 79px;
            }
          }
          .number-wrap {
            width: 220px;
            position: absolute;
            top: 85px;
            right: 44px;
            display: flex;
            justify-content: space-between;
            .reward,
            .signup-users {
              h3 {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #677489;
                margin: 0;
                margin-bottom: 14px;
              }
              p {
                font-size: 20px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #3571b7;
                margin: 0;
              }
            }
          }
          max-width: 1200px;
          height: 216px;
          background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%);
          box-shadow: 0px 16px 16px -5px rgba(0, 0, 0, 0.03),
            0px 1px 1px 0px #e8edf3;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 2px solid;
          padding: 26px 20px;
          box-sizing: border-box;
          border-image: linear-gradient(
              180deg,
              rgba(255, 255, 255, 1),
              rgba(255, 255, 255, 1)
            )
            2 2;

          display: flex;
          .cmpt-des {
            margin: 13px 0;
            p {
              width: 650px;
              font-size: 14px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #535352;
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }
          }
          .cmpt-organ {
            p {
              display: flex;
              margin-bottom: 4px;
              span:nth-of-type(odd) {
                display: inline-block;
                width: 60px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                line-height: 17px;
              }
              span:nth-of-type(even) {
                display: inline-block;
                // width: 528px;
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #6e8094;
                line-height: 17px;
                margin-right: 20px;
              }
            }
            p:nth-last-of-type(1) {
              span:nth-of-type(2) {
                width: 528px;
              }
            }
          }
        }
        .cover {
          width: 204px;
          height: 149px;
          object-fit: fill;
          cursor: pointer;
          img {
            width: 204px;
            height: 149px;
          }
        }
        .texts {
          padding-left: 22px;
          .cmpt-title {
            h2 {
              font-size: 20px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #36383a;
              margin: 0;
              margin-right: 20px;
              cursor: pointer;
            }
            display: flex;
            span {
              display: inline-block;
              height: 21px;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 1px solid #4e75df;
              font-size: 11px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #003cbe;
              line-height: 21px;
              padding: 3px 7px;
              margin-right: 8px;
            }
          }
        }
        .cmpt-item:nth-of-type(1) {
          .texts {
            .cmpt-title {
              span:nth-of-type(2) {
                border: 1px solid #3573b9;
                color: #3573b9;
              }
            }
          }
        }
        .cmpt-item:nth-of-type(2) {
          .texts {
            .cmpt-title {
              span:nth-of-type(2) {
                border: 1px solid #36a053;
                color: #36a053;
              }
            }
          }
        }
        .cmpt-item:nth-of-type(3) {
          .texts {
            .cmpt-title {
              span:nth-of-type(2) {
                border: 1px solid #de4436;
                color: #de4436;
              }
            }
          }
        }
      }
    }
    .s2 {
      padding-top: 81px;
      max-width: 1200px;
      margin: 0 auto;
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        padding-top: 32px;
        overflow: hidden;
        video {
          max-width: 1200px;
          height: 635px;
          margin-left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .s3 {
      padding-top: 81px;
      max-width: 1200px;
      margin: 0 auto;
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        padding-top: 37px;
        display: flex;
        .left {
          width: 639px;
          height: 472px;
          object-fit: fill;
          position: relative;
          cursor: pointer;
          .icon-time-1 {
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url("../assets/naic/home/icon-time-1.png") no-repeat
              center center;
            background-size: 14px;
            transform: translateY(1px);
            margin-right: 3px;
          }
          img {
            width: 639px;
            height: 472px;
          }
          .text {
            position: absolute;
            bottom: 0;
            left: 0;
            width: calc(100% - 32px);
            height: 42px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            .title {
              height: 22px;
              font-size: 18px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 22px;
            }
            .time {
              height: 19px;
              font-size: 14px;
              font-family: Noto Sans-Medium, Noto Sans;
              font-weight: 500;
              color: #ffffff;
            }
          }
        }
        .right {
          margin-left: 20px;
          .s3ri {
            .icon-time-2 {
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url("../assets/naic/home/icon-time-2.png") no-repeat
                center center;
              background-size: 14px;
              transform: translateY(1px);
              margin-right: 3px;
            }
            cursor: pointer;
            display: flex;
            &:not(:nth-last-of-type(1)) {
              margin-bottom: 20px;
            }
            .img {
              width: 256px;
              height: 144px;
              object-fit: fill;
              img {
                width: 256px;
                height: 144px;
              }
            }
            .text {
              padding: 10px;
              h3 {
                font-size: 18px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #36383a;
                line-height: 22px;
                margin: 0;
              }
              p {
                margin-top: 24px;
                font-size: 14px;
                font-family: Noto Sans-Medium, Noto Sans;
                font-weight: 500;
                color: #535352;
              }
            }
          }
        }
      }
    }

    .s4 {
      padding-top: 114px;
      max-width: 1200px;
      margin: 0 auto;
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        height: 555px;
        // border: 1px solid #000;
        position: relative;
        .s4-s {
          width: 76px;
          height: 128px;
          text-align: center;
          h4 {
            font-size: 28px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #36383a;
            text-align: center;
          }
          p {
            font-size: 13px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            margin-top: 3px;
            color: #535352;
            text-align: center;
            display: inline-block;
            text-align: center;
          }
          .img {
            width: 60px;
            height: 60px;
            object-fit: fill;
            padding-top: 6px;
            padding-left: 8px;
            img {
              width: 60px;
              height: 60px;
            }
          }
        }
        .s41 {
          position: absolute;
          left: 99px;
          top: 233px;
        }
        .s42 {
          position: absolute;
          left: 391px;
          top: 144px;
        }
        .s43 {
          position: absolute;
          left: 699px;
          top: 67px;
        }
        .s44 {
          position: absolute;
          left: 1046px;
          top: 86px;
        }
      }
    }

    .s5 {
      max-width: 1200px;
      margin: 0 auto;
      .s5-tips {
        text-align: center;
        line-height: 20px;
        font-size: 14px;
        margin-top: 20px;
      }
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        display: flex;
        padding-top: 47px;
        .item {
          width: 289px;
          height: 297px;
          background: linear-gradient(180deg, #f4f7fb 0%, #ffffff 100%);
          box-shadow: 0px 16px 16px -5px rgba(0, 0, 0, 0.03),
            0px 1px 1px 0px #e8edf3;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          border: 2px solid #ffffff;
          text-align: center;
          &:not(:nth-last-of-type(1)) {
            margin-right: 15px;
          }
          .img {
            width: 136px;
            height: 130px;
            object-fit: fill;
            margin: 0 auto;
            padding-top: 20px;
            margin-bottom: 8px;
            img {
              width: 136px;
              height: 130px;
            }
          }
          .text {
            height: 29px;
            background: url("../assets/naic/home/s55.png") no-repeat center
              center;
            background-size: 106px 29px;
            text-align: center;
            margin: 0 auto;
            .label {
              font-size: 20px;
              font-family: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #535352;
            }
            .track {
              font-size: 13px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #535352;
              text-align: center;
            }
          }
          &:nth-of-type(1) {
            .text {
              .reward {
                margin-top: 20px;
                font-size: 34px;
                font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
                font-weight: 400;
                color: #df9d1c;
                line-height: 30px;
                span {
                  font-size: 22px;
                  font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
                  font-weight: 400;
                  color: #df9d1c;
                }
              }
            }
          }
          &:nth-of-type(2) {
            .text {
              .reward {
                margin-top: 20px;
                font-size: 34px;
                font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
                font-weight: 400;
                color: #1f5bb6;
                line-height: 50px;
              }
            }
          }
          &:nth-of-type(3) {
            .text {
              .reward {
                margin-top: 20px;
                font-size: 34px;
                font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
                font-weight: 400;
                color: #b16a32;
                line-height: 50px;
              }
            }
          }
          &:nth-of-type(4) {
            .text {
              .reward {
                margin-top: 20px;
                font-size: 34px;
                font-family: DingTalk JinBuTi-Regular, DingTalk JinBuTi;
                font-weight: 400;
                color: #36383a;
                line-height: 50px;
              }
            }
          }
        }
      }
    }

    .s6 {
      padding-top: 56px;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 44px;
      background: #151b28;
      border-radius: 8px;
      height: 800px;
      .section-title {
        text-align: center;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        padding: 60px 124px;
        .line {
          display: flex;
          &:nth-of-type(1) {
            justify-content: space-between;
            .item {
              width: 212px;
              height: 184px;
              background: #1c2534;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 1px solid #353f52;
              padding: 30px 36px;
              .img {
                width: 64px;
                height: 64px;
                object-fit: fill;
                margin: 0 auto;
                img {
                  width: 64px;
                  height: 64px;
                }
              }
              .label {
                font-size: 26px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #f9f9f9;
                line-height: 30px;
                margin: 0 auto;
                text-align: center;
                border-bottom: 1px solid #2e3545;
                padding-top: 19px;
                padding-bottom: 12px;
              }
              p {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #f9f9f9;
                line-height: 23px;
                margin-top: 12px;
              }
            }
          }
          &:nth-of-type(2) {
            justify-content: space-around;
            padding-top: 53px;
            .item {
              width: 305px;
              height: 203px;
              background: #1c2534;
              border-radius: 4px 4px 4px 4px;
              opacity: 1;
              border: 1px solid #353f52;
              padding: 30px 36px;
              .img {
                width: 64px;
                height: 64px;
                object-fit: fill;
                margin: 0 auto;
                img {
                  width: 64px;
                  height: 64px;
                }
              }
              .label {
                font-size: 26px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #f9f9f9;
                line-height: 30px;
                margin: 0 auto;
                text-align: center;
                border-bottom: 1px solid #2e3545;
                padding-top: 19px;
                padding-bottom: 12px;
              }
              p {
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #f9f9f9;
                line-height: 23px;
                margin-top: 12px;
              }
            }
          }
        }
      }
    }

    .s7 {
      max-width: 1200px;
      height: 1127px;
      background: url("../assets/naic/home/s7-bg.png") no-repeat center center;
      background-size: 1200px 1127px;
      // padding-top: 49px;
      max-width: 1200px;
      margin: 0 auto;
      .section-title {
        text-align: center;
        padding-top: 49px;
        img {
          width: 208px;
          height: 50px;
        }
      }
      .content-wrap {
        padding: 0 80px;
        .line-1 {
          width: 836px;
        }
        .line-2 {
          width: 836px;
        }
        .line-3 {
          width: 560px;
        }
        .line {
          display: flex;
          justify-content: space-between;
          margin: 0 auto;
          margin-top: 10px;
          .item {
            width: 248px;
            height: 328px;
            position: relative;
            .img {
              width: 248px;
              height: 328px;
              object-fit: fill;
              img {
                width: 248px;
                height: 328px;
                // transform: scale(1.2);
              }
            }
            h3 {
              position: absolute;
              width: 100%;
              top: 174px;
              font-size: 24px;
              font-family: PingFang SC-Semibold, PingFang SC;
              font-weight: 600;
              color: #36383a;
              text-align: center;
              line-height: 19px;
              margin: 0;
            }
            p {
              margin: 0;
              text-align: center;
            }
            p:nth-of-type(1) {
              position: absolute;
              text-align: center;
              width: 100%;
              bottom: 111px;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #3573b9;
              line-height: 13px;
            }
            p:nth-of-type(2) {
              position: absolute;
              text-align: center;
              width: 100%;
              bottom: 43px;
              line-height: 20px;
              font-size: 16px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #535352;
            }
          }
        }
      }
    }
    .s8 {
      max-width: 1200px;
      height: 251px;
      background: url("../assets/naic/home/s8-bg.png") no-repeat center center;
      background-size: 1200px 251px;
      margin: 0 auto;
      .content-wrap {
        padding-top: 45px;
        h2 {
          font-size: 32px;
          font-family: Noto Sans-ExtraBold Italic, Noto Sans;
          font-weight: normal;
          color: #ffffff;
          text-align: center;
          margin-bottom: 9px;
        }
        p {
          font-size: 24px;
          font-family: Noto Sans-Regular, Noto Sans;
          font-weight: 400;
          color: #ffffff;
          text-align: center;
          margin-bottom: 29px;
        }
        a {
          display: inline-block;
          width: 178px;
          height: 46px;
          background: #ffffff;
          border-radius: 100px 100px 100px 100px;
          opacity: 1;
          border: 1px solid #ffffff;
          font-size: 22px;
          font-family: Noto Sans-Display Medium Italic, Noto Sans;
          font-weight: normal;
          color: #1731ac;
          text-align: center;
          line-height: 46px;
          text-decoration: none;
          margin-left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
</style>
